import React from 'react';
import Graphics from './Graphics/Graphics';
import TopBar from './TopBar/TopBar';

const Main = () => {
  return (
    <div>
      <TopBar />
      <Graphics />
    </div>
  );
}

export default Main;
